/**
 * Onglet Historique — mode dégradé honnête.
 * Ne simule pas d’événements à partir de createdAt / updatedAt.
 */
export default function MaterielDrawerHistoryTab() {
  return (
    <div className="rounded-md border border-dashed border-gray-200 bg-gray-50 px-3 py-4 space-y-2">
      <p className="text-sm font-medium text-gray-800">Historique des affectations</p>
      <p className="text-sm text-gray-600 leading-relaxed">
        L&apos;historique détaillé des affectations n&apos;est pas encore disponible.
      </p>
      <p className="text-xs text-gray-500">
        Les dates d&apos;ajout et de dernière modification restent consultables dans
        l&apos;onglet Informations.
      </p>
    </div>
  );
}
